import { zVehicleManufacturerCommonSchema } from "./vehicleManufacturer.common";
// DTO схема для VehicleManufacturer
export const zVehicleManufacturerSchemaDto = zVehicleManufacturerCommonSchema;
export const zVehicleManufacturerSchemaCreateDto = zVehicleManufacturerSchemaDto.omit({
    id: true,
});
